import PropTypes from 'prop-types';
import React from 'react';
import { Panel } from 'react-bootstrap';
import { commissionType } from './CommissionPropTypes';
import CommissionBadge from './CommissionBadge';

class CommissionOverview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      needCalc: true,
      sum: { paid: 0, due: 0, pending: 0, overdue: 0 },
      filterByCurrency: 'USD'
    };

    this.handleCurrencyFilterChange = this.handleCurrencyFilterChange.bind(this);
  }
  componentDidMount() {
    // if (this.state.needCalc) {
    this.props.requestCommissionOverview(this.state.filterByCurrency);
    // this.updateStats(this.props.commissions);
    // }
  }

  handleCurrencyFilterChange(currency) {
    this.props.requestCommissionOverview(currency);
    this.state.filterByCurrency = currency;
  }

  componentWillReceiveProps(nextProps) {
    // if (nextProps.commissionOverview !== this.props.commissionOverview) {
    //   this.updateStats(nextProps.commissions);
    // }
  }
  updateStats(commissions) {
    const sum = { paid: 0, due: 0, pending: 0, overdue: 0 };
    commissions.forEach((commission) => {
      const state = commission.state.toLowerCase();
      sum[state] += commission.value;
    });
    this.setState({
      needCalc: false,
      sum,
    });
  }
  renderLoading() {
    const spinner = (
      <div className="text-center">
        <i className="fa fa-spinner fa-pulse fa-5x fa-fw" />
        <span className="sr-only">Loading...</span>
      </div>
    );
    return (
      <div className="row">
        <div className="planner col-sm-12">
          <div className="col-sm-3">

            <Panel header="Overdue">
              {spinner}
            </Panel>
          </div>
          <div className="col-sm-3">
            <Panel header="Due">
              {spinner}
            </Panel>
          </div>
          <div className="col-sm-3">
            <Panel header="Pending">
              {spinner}
            </Panel>
          </div>
          <div className="col-sm-3">
            <Panel header="Paid">
              {spinner}
            </Panel>
          </div>
        </div>
      </div>
    );
  }
  emptyOverview() {
    return (
      <div className="row">
        <div className="planner col-sm-12">
          <div className="col-sm-3">
            <Panel header="Overdue">
              <h2> </h2>
            </Panel>
          </div>
          <div className="col-sm-3">
            <Panel header="Due">
              <h2> </h2>
            </Panel>
          </div>
          <div className="col-sm-3">
            <Panel header="Pending">
              <h2></h2>
            </Panel>
          </div>
          <div className="col-sm-3">
            <Panel header="Paid">
              <h2></h2>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
  render() {
    if(this.props.currencyFilter){
      if(Object.keys(this.props.currencyFilter).length > 0){
        const currency = Object.keys(this.props.currencyFilter)[0];
        if(this.state.filterByCurrency !== currency){
          this.handleCurrencyFilterChange(currency);
        }
      }
    }
    if (this.props.commissionOverview == null) {
      return this.renderLoading();
    }
    if(this.state.filterByCurrency == ""){
      return this.emptyOverview();
    }
    return (
      <div>
        <div className="row tour-head">
          <div className="col-md-12 tour-headText">
            <h2>Commissions</h2>
          </div>
        </div>
        <hr />
        <div className="row planner">
          <CommissionBadge
            title="Overdue"
            value={this.props.commissionOverview.overdue}
            currency={this.state.filterByCurrency}
          />
          <CommissionBadge
            title="Due"
            value={this.props.commissionOverview.due}
            currency={this.state.filterByCurrency}
          />
          <CommissionBadge
            title="Pending"
            value={this.props.commissionOverview.pending}
            currency={this.state.filterByCurrency}
          />
          <CommissionBadge
            title="Paid"
            value={this.props.commissionOverview.paid}
            currency={this.state.filterByCurrency}
          />
        </div>
      </div>
    );
  }
}

CommissionOverview.propTypes = {
  commissions: PropTypes.arrayOf(
    PropTypes.shape({ commissionType }),
  ).isRequired,
};
export default CommissionOverview;



// WEBPACK FOOTER //
// src/routes/commissions/components/CommissionOverview.js